import styled from 'styled-components';
import { Field } from 'formik';
import { themed } from '@/shared/ui/core';

export const FieldWrapper = styled.fieldset`
  align-items: center;
  border: 0;
  display: flex;
  justify-content: space-between;
  padding: 1rem 0;

  input:checked + label {
    background-color: ${themed('primary.main')};
    border: 1px solid ${themed('primary.main')};

    svg {
      fill: white;
      width: 50%;
    }
  }
`;

export const RadioField = styled(Field)`
  ${themed('visuallyHidden')}
`;

export const Label = styled.label`
  align-items: center;
  border: 1px solid ${themed('lightGray')};
  border-radius: .5rem;
  display: flex;
  justify-content: center;
  height: 1.75rem;
  width: 1.75rem;
`;
